import {IBaseLookup} from "./Ibase.lookup";

export namespace OrderPriority {

	export const lookupName: string = "OrderPriority";

	export interface OrderPriority {
		priorityKey: number;
		code: string;
		description: string;
		active: string;
		lastUpdated: Date;
		color: string;
		priority: number;
	}

	export interface OrderPriorityDS extends IBaseLookup {
		orderPriority: OrderPriority[];
	}
}
